import { useEffect, useRef } from 'react'

export function useClickOutside(handler: () => void) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking the ref's element or its children
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }
      handler()
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
    // The ref object is stable and doesn't need to be in the dependency array
  }, [handler])

  return ref
}